var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.className,style:({fontSize:_vm.fontSize})},[_vm._v(_vm._s(_vm.num * 1 >= 10000 ? '9999+': _vm.num))])}
var staticRenderFns = []

export { render, staticRenderFns }